export const DS_TIMEPICKER_CLASSES = {
  Root: "ds-time-picker",
} as const;
